export default function WhatIsSection() {
  return (
    <section id="o-que-e" className="py-20 lg:py-24" style={{ backgroundColor: '#FFFFFF', borderBottom: '1px solid #F0F0F0' }}>
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="h-px w-8" style={{ backgroundColor: '#D1D5DB' }} />
              <span style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.7rem', fontWeight: 600, letterSpacing: '0.12em', textTransform: 'uppercase', color: '#9CA3AF' }}>
                O serviço
              </span>
            </div>
            <h2
              style={{ fontFamily: 'DM Sans, sans-serif', fontWeight: 700, fontSize: 'clamp(1.5rem, 3vw, 1.875rem)', lineHeight: 1.25, color: '#1a1a1a', marginBottom: '1.25rem', letterSpacing: '-0.02em' }}
            >
              O que é o GP Otimiza?
            </h2>
            <p style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.95rem', color: '#4B5563', lineHeight: 1.8, marginBottom: '1rem' }}>
              O GP Otimiza é um serviço técnico e estratégico da GestPub criado para apoiar Municípios na melhoria da sua organização interna.
            </p>
            <p style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.95rem', color: '#4B5563', lineHeight: 1.8, marginBottom: '1rem' }}>
              Através de diagnóstico, análise funcional e recomendações práticas, permite alinhar pessoas, processos e desempenho com as prioridades políticas e estratégicas do executivo municipal.
            </p>
            <p style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.95rem', color: '#4B5563', lineHeight: 1.8 }}>
              O objetivo é simples: ajudar a máquina municipal a funcionar melhor por dentro, com mais clareza, eficiência, articulação e capacidade de execução.
            </p>
          </div>

          {/* Right side — key pillars */}
          <div className="space-y-4">
            {[
              {
                label: 'Pessoas',
                abbr: 'PE',
                description: 'Clarificação de funções, responsabilidades e liderança intermédia orientada para resultados.',
              },
              {
                label: 'Processos',
                abbr: 'PR',
                description: 'Revisão e simplificação dos circuitos internos, eliminação de redundâncias e melhoria da articulação entre serviços.',
              },
              {
                label: 'Desempenho',
                abbr: 'DE',
                description: 'Definição de indicadores, mecanismos de monitorização e reforço da capacidade de execução das prioridades do mandato.',
              },
            ]?.map((pillar) => (
              <div
                key={pillar?.label}
                className="flex gap-5 p-6"
                style={{ borderRadius: '6px', backgroundColor: '#FAFAFA', border: '1px solid #EBEBEB' }}
              >
                <div
                  className="flex-shrink-0 flex items-center justify-center"
                  style={{ width: '2.75rem', height: '2.75rem', borderRadius: '5px', backgroundColor: '#272727', color: '#FFFFFF' }}
                >
                  <span style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.7rem', fontWeight: 700, letterSpacing: '0.06em' }}>
                    {pillar?.abbr}
                  </span>
                </div>
                <div>
                  <h4
                    style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '1rem', fontWeight: 700, color: '#1a1a1a', marginBottom: '0.3rem', letterSpacing: '-0.01em' }}
                  >
                    {pillar?.label}
                  </h4>
                  <p style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.875rem', color: '#6B7280', lineHeight: 1.7 }}>
                    {pillar?.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
